import React from 'react'

import AlgoliaArticles from 'components/shared/AlgoliaArticles'
import CirclePictureContent from 'components/shared/CardWithArrowLink/CirclePictureContent'
import SliceManager from 'components/shared/SliceManager'
import TitleHero from 'components/slices/TitleHero'

import { algoliaIntegrationsAdapter } from 'adapters/integrations'
import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'
import { getDataDependencies } from 'services/api'
import algolia from 'src/services/algolia'
import { fetchFacets } from 'src/services/algoliaHelpers'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

const index = 'integrations'
const Integrations = ({
  pageData: { intro, decoration, slices },
  articles,
  facets,
}) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps

  return (
    <div className="container">
      {intro && <TitleHero {...intro} decoration={decoration} />}
      <AlgoliaArticles
        index={index}
        initialAlgolia={articles}
        adapter={algoliaIntegrationsAdapter}
        placeholder="Search an integration"
        labelType="Integrations"
        pathname="/integrations"
        facets={facets}
        fullSearch={Object.keys(facets).length === 0}
        customCardComponent={CirclePictureContent}
        customCardProps={customCardProps}
      />

      {slices && <SliceManager slices={slices} />}
    </div>
  )
}

const integrationsFacets = {
  cards_categories: {
    label: 'Categories',
    multi: true,
  },
}

export async function getServerSideProps() {
  const articles = await algolia(index).search('', {
    hitsPerPage: 6,
    page: 0,
    filters: 'publishedAt:true',
  })

  const facets = await fetchFacets([index, integrationsFacets])
  const pageData = await fetchSingleType('integrations-grid')
  const extendedData = await getDataDependencies(pageData)

  return {
    props: {
      pageData: extendedData,
      articles,
      facets,
    },
  }
}

export default Integrations
